<template>
  <v-app class="login-bg recover-fondo">
    <div class="login-pagina" :class="{ 'login-pagina--teclado': tecladoAbierto }">
      <div class="recover-caja">
        <img class="login-logo" src="/assets/images/brand/white-horizontal-logo.svg" alt="Nubempresa">

        <div class="auth-glass login-tarjeta">
          <div class="d-flex align-center justify-space-between mb-4">
            <v-btn to="/" color="success" class="rounded-pill" small elevation="0" outlined>
              <v-icon small left>mdi-chevron-left</v-icon>
              {{ $t("go_back") }}
            </v-btn>
            <v-switch v-model="keyboardMode" inset dense hide-details class="login-teclado mt-0 pt-0"
              prepend-icon="mdi-keyboard" label="Teclado" title="Teclado en pantalla"></v-switch>
          </div>

          <div class="text-center mb-5">
            <div class="login-encabezado">
              <div class="login-insignia"><v-icon color="white" size="26">mdi-lock-reset</v-icon></div>
              <h1 class="login-titulo success--text">Recuperar contraseña</h1>
            </div>
            <p class="grey--text text--darken-2 mb-0">{{ instruccion }}</p>
          </div>

          <div class="recover-pasos mb-5" aria-hidden="true">
            <span v-for="n in 3" :key="n" class="recover-paso"
              :class="{ 'recover-paso--hecho': n < step, 'recover-paso--actual': n === step }"></span>
          </div>

          <ValidationObserver v-slot="{ invalid }" ref="form">
            <form class="v-form" @submit.prevent>
              <div v-if="step == 1">
                <div @focusin="campoActivo = 'user'" @click="campoActivo = 'user'">
                  <ng-text prepend-inner-icon="mdi-email-outline" autocomplete="off" v-model="form.user" :filled="false"
                    :dense="false" :label="'Correo'" rules="required|email" show-required="true"
                    v-on:keyup.enter="recoverPasswd" :inputmode="keyboardMode ? 'none' : undefined" />
                </div>
                <v-btn elevation="0" block large color="success" :disabled="invalid || enviando" :loading="enviando"
                  @click="recoverPasswd">
                  {{ $t("recover_your_password") }}
                </v-btn>
              </div>

              <div v-if="step == 2">
                <div @focusin="campoActivo = 'code'" @click="campoActivo = 'code'">
                  <ng-text prepend-inner-icon="mdi-numeric" autocomplete="off" v-model="code" :filled="false"
                    :dense="false" :label="$t('code')" rules="required" show-required="true"
                    v-on:keyup.enter="continuar" :inputmode="keyboardMode ? 'none' : undefined" />
                </div>
                <v-btn elevation="0" block large color="success" :disabled="!code || invalid" @click="continuar">
                  {{ $t("continue") }}
                </v-btn>
              </div>

              <div v-if="step == 3">
                <div @focusin="campoActivo = 'password'" @click="campoActivo = 'password'">
                  <ng-passwd prepend-inner-icon="mdi-lock-outline" autocomplete="new-password" v-model="password" counter
                    :filled="false" :dense="false" :label="$t('password')" rules="required|min:8" show-required="true"
                    v-on:keyup.enter="changePasswd" :inputmode="keyboardMode ? 'none' : undefined" />
                </div>
                <v-btn elevation="0" block large color="success" :disabled="!password || invalid || enviando"
                  :loading="enviando" @click="changePasswd">
                  {{ $t("change_password") }}
                </v-btn>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
    <tecladoLogin :abierto="tecladoAbierto" :valor="valorCampo" :etiqueta="etiquetaCampo" :accion="textoAccion"
      @cambio="escribirDesdeTeclado" @accion="accionTeclado" @cerrar="tecladoOculto = true" />
  </v-app>
</template>

<style lang="scss" src="@/components/base/estilos-login.scss"></style>

<style lang="scss">
/* Recuperar contraseña va en verde (el login en azul): se nota que es otra pantalla, no el acceso normal. */
.login-bg.recover-fondo {
  background-image: radial-gradient(rgba(255, 255, 255, 0.07) 1px, transparent 1.5px),
    radial-gradient(circle at 12% 18%, rgba(129, 199, 132, 0.28), transparent 42%),
    radial-gradient(circle at 88% 85%, rgba(76, 175, 80, 0.4), transparent 52%),
    linear-gradient(135deg, #0a2418 0%, #0f3d29 50%, #14563a 100%) !important;
}

.recover-caja {
  position: relative;
  width: 100%;
  max-width: 440px;
  margin: 0 auto;
}

.login-logo {
  display: block;
  width: 64%;
  max-width: 260px;
  margin: 0 auto 20px;
}

/* Los tres pasos: el actual en verde, los hechos en verde claro. */
.recover-pasos {
  display: flex;
  gap: 8px;
}

.recover-paso {
  flex: 1;
  height: 5px;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.12);
}

.recover-paso--hecho {
  background: #a5d6a7;
}

.recover-paso--actual {
  background: #4caf50;
}
</style>

<script>
import TecladoLogin from "@/components/base/TecladoLogin.vue";
import MixinTecladoLogin from "@/components/base/MixinTecladoLogin";

export default {
  name: "Recover",
  components: { tecladoLogin: TecladoLogin },
  mixins: [MixinTecladoLogin],
  data: () => ({
    form: { user: "" },
    password: "",
    code: "",
    hash: "",
    step: 1,
    enviando: false,
  }),
  computed: {
    instruccion() {
      if (this.step === 1) return "Escribe tu correo y te enviaremos un código para cambiar tu contraseña.";
      return this.$t(this.step === 2 ? "recovery_msg_step_2" : "recovery_msg_step_3");
    },
    valorCampo() {
      if (this.campoActivo === "user") return this.form.user || "";
      if (this.campoActivo === "code") return this.code || "";
      if (this.campoActivo === "password") return this.password || "";
      return "";
    },
    etiquetaCampo() {
      return { user: "Correo", code: this.$t("code"), password: this.$t("password") }[this.campoActivo] || "";
    },
    textoAccion() {
      return { user: "Enviar código", code: "Continuar", password: "Cambiar" }[this.campoActivo] || "Siguiente";
    },
  },
  watch: {
    step(paso) {
      // Cada paso tiene un solo campo: se deja activo y el teclado (si está encendido) pasa a él.
      this.campoActivo = null;
      this.$nextTick(() => {
        const campo = this.$el.querySelector(".login-tarjeta form input");
        if (campo) campo.focus();
      });
    },
  },
  methods: {
    escribirDesdeTeclado(texto) {
      if (this.campoActivo === "user") this.form.user = texto;
      else if (this.campoActivo === "code") this.code = texto;
      else if (this.campoActivo === "password") this.password = texto;
    },
    accionTeclado() {
      this.$refs.form.validate().then((valido) => {
        if (!valido) return;
        this.tecladoOculto = true;
        if (this.campoActivo === "user") this.recoverPasswd();
        else if (this.campoActivo === "code") this.continuar();
        else this.changePasswd();
      });
    },
    continuar() {
      if (this.code) this.step = 3;
    },
    recoverPasswd() {
      if (this.enviando || !this.form.user) return;
      this.enviando = true;
      this.$http
        .post("api/password/send-code", { email: this.form.user }, false, false)
        .then((res) => {
          if (res.success) {
            this.hash = res.hash;
            this.step = 2;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.enviando = false;
        });
    },
    changePasswd() {
      if (this.enviando || !this.password) return;
      this.enviando = true;
      const data = {
        code: this.code,
        password: this.password,
        email: this.form.user,
        hash: this.hash,
      };
      this.$http
        .post("api/password/change", data, true, false)
        .then((res) => {
          if (res.success) {
            setTimeout(() => {
              this.$router.push("/");
            }, 1000);
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.enviando = false;
        });
    },
  },
};
</script>
